import constants from 'app/shared/constants/ConstantsBundle';
import reduxUtils from 'app/shared/utils/reduxUtils';
import assign from 'lodash/assign';

export interface SeoLink {
  name: string;
  uriV2?: string;
  listingCount?: number;
}

export interface SeoLinkGroup {
  header: string;
  links: Array<SeoLink>;
}

export interface SeoFooterLinks {
  groups?: Array<SeoLinkGroup>;
}

export interface SEOState {
  seoFooterLinks: SeoFooterLinks;
}

const initState = (): SEOState => ({
  seoFooterLinks: {},
});

const mapActionsToReducer = {
  [constants.LOAD_SEO_FOOTER_LINKS]: (
    state: SEOState,
    action: {
      payload: {
        seoFooterLinks: SeoFooterLinks;
      };
    },
  ): SEOState => {
    const { seoFooterLinks } = action.payload;
    return assign({}, state, { seoFooterLinks });
  },
};

const seo = reduxUtils.createReducer(mapActionsToReducer, initState());

export default seo;
